import APIContext from 'contexts/base/APIContext'

export default class FinancialYearsContext extends APIContext{
  static contextName = 'financialYears'
}
